<template>
  <div class="suggestField">
    <input
      v-model="modelValue"
      :placeholder="placeholder"
      :disabled="disabled"
      @focus="openSuggest(value)"
    >
    <div v-if="isSuggest" class="suggestField__container">
      <Loading v-if="isLoading" min-height="160px" />
      <div v-else-if="suggests.length" class="suggestField__items">
        <button
          v-for="suggest in suggests"
          :key="suggest[idKey]"
          type="button"
          :class="{ 'is-current': currentSuggest && suggest[idKey] === currentSuggest[idKey] }"
          @click.stop="selectSuggest(suggest)"
        >
          <span v-html="sanitize(suggest[nameKey])" />
        </button>
      </div>
      <p v-else class="suggestField__noItem">{{ $t('components.SuggestField.noItem') }}</p>
    </div>
  </div>
</template>

<script>
import DOMPurify from 'dompurify'
import Loading from './Loading'

export default {
  name: 'SuggestField',
  components: {
    Loading,
  },
  props: {
    id: {
      type: [String, Number],
      default: undefined,
    },
    value: {
      type: String,
    },
    idKey: {
      type: String,
      default: 'id',
    },
    nameKey: {
      type: String,
      default: 'name',
    },
    placeholder: {
      type: String,
      default: '',
    },
    suggests: {
      type: Array,
      default: () => [],
    },
    currentSuggest: {
      type: Object,
      default: () => {},
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false
    },
  },
  emits: [
    'input',
    'input-field',
    'focus-field',
    'select-suggest',
    'close-suggest'
  ],
  data() {
    return {
      isSuggest: false,
    }
  },
  computed: {
    modelValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
        this.$emit('input-field', { value: newValue, id: this.id })
      }
    }
  },
  watch: {
    isSuggest(newValue) {
      if (newValue) {
        window.addEventListener('click', this.closeSuggest)
      } else {
        window.removeEventListener('click', this.closeSuggest)
      }
    }
  },
  beforeUnmount() {
    window.removeEventListener('click', this.closeSuggest)
  },
  methods: {
    openSuggest(suggest) {
      this.isSuggest = true
      this.$emit('focus-field', suggest)
    },
    closeSuggest(event) {
      if (!this.$el.contains(event.target)) {
        this.isSuggest = false
        this.$emit('close-suggest', this.id)
      }
    },
    selectSuggest(suggest) {
      this.isSuggest = false
      this.$emit('select-suggest', { suggest, id: this.id })
    },
    sanitize(html) {
      return DOMPurify.sanitize(html)
    }
  },
}
</script>
<style lang="scss" scoped>
.suggestField {
  display: block;
  position: relative;
  input {
    display: block;
    width: 100%;
    height: 48px;
    padding: 0 16px;
    border: 1px solid #E4E7EB;
    border-radius: 4px;
    background-color: #FFF;
    font-size: 14px;
    line-height: 1.5;
  }
  &__container {
    position: absolute;
    top: 100%;
    left: 0;
    z-index: 1;
    min-width: 100%;
    max-height: 240px;
    padding: 8px 0;
    border-radius: 4px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, .05);
    overflow-x: auto;
    background: #FFF;
    white-space: nowrap;
  }
  &__items {
    button {
      display: block;
      width: 100%;
      padding: 12px 24px;
      text-align: left;
      transition: .2s;
      &:hover,
      &.is-current {
        background-color: #E5E5E5;
      }
    }
  }
  &__noItem {
    padding: 8px 16px;
  }
}
</style>
